import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { UiSwitchModule } from 'ngx-ui-switch';
import { CookieService } from 'ngx-cookie-service';
import { CookiesPolicyPageComponent } from '@app/shared/components/cookies-policy-page/cookies-policy-page.component';
import { PlacesAutocompleteComponent } from '@app/shared/components/places-autocomplete/places-autocomplete.component';
import { RatingBarComponent } from '@app/shared/components/rating-bar/rating-bar.component';
import { RatingStarsComponent } from '@app/shared/components/rating-stars/rating-stars.component';
import { IconsModule } from '@app/shared/icons/icons.module';
import { FooterComponent } from '@app/shared/layout/footer/footer.component';
import { NavbarComponent } from '@app/shared/layout/navbar/navbar.component';
import { SpinnerComponent } from '@app/shared/layout/spinner/spinner.component';
import { MonthAbbrevTranslationKeyFromDate } from '@app/shared/pipes/month-abbrev-translation-key-from-date.pipe';
import { MonthNameTranslationKeyFromDate } from '@app/shared/pipes/month-name-translation-key-from-date.pipe';
import { SalonFormattedAddressPipe } from '@app/shared/pipes/salon-formatted-address.pipe';
import { VisitSlotDatePipe } from '@app/shared/pipes/visit-slot-date.pipe';
import { WeekDayTranslationKeyFromDate } from '@app/shared/pipes/week-day-translation-key-from-date.pipe';
import { CookieConsentPopupComponent } from '@app/shared/services/cookie-consent-popup/component/cookie-consent-popup.component';
import { OkDialogComponent } from '@app/shared/services/dialogs/ok-dialog/ok-dialog.component';
import { YesNoDialogComponent } from '@app/shared/services/dialogs/yes-no-dialog/yes-no-dialog.component';
import { ValidateOnBlurDirective } from '@app/shared/validators/validate-onblur/validate-onblur.directive';
import { BadgeGiftsComponent } from '@app/shared/components/badge-gifts/badge-gifts.component';
import { TruncatePipe } from '@app/shared/pipes/truncate-long-string.pipe';
import { ReviewItemComponent } from '@app/shared/components/review-item/review-item.component';
import { InputTrimDirective } from '@app/shared/directives/trim/input-trim.directive';
import { UnsupportedBrowserNotificationComponent } from '@app/shared/components/unsupported-browser-notification/unsupported-browser-notification.component';
import { BadgeGiftsDescriptionDumbComponent } from '@app/shared/components/badge-gifts/badge-gifts-description/badge-gifts-description.dumb.component';

@NgModule({
  declarations: [
    NavbarComponent,
    FooterComponent,
    SpinnerComponent,
    YesNoDialogComponent,
    OkDialogComponent,
    PlacesAutocompleteComponent,
    VisitSlotDatePipe,
    CookiesPolicyPageComponent,
    CookieConsentPopupComponent,
    SalonFormattedAddressPipe,
    MonthAbbrevTranslationKeyFromDate,
    MonthNameTranslationKeyFromDate,
    WeekDayTranslationKeyFromDate,
    RatingStarsComponent,
    RatingBarComponent,
    ValidateOnBlurDirective,
    TruncatePipe,
    ReviewItemComponent,
    InputTrimDirective,
    UnsupportedBrowserNotificationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IconsModule,
    RouterModule,
    TranslateModule,
    BrowserAnimationsModule,
    UiSwitchModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    BadgeGiftsComponent,
    BadgeGiftsDescriptionDumbComponent
  ],
  exports: [
    TranslateModule,
    RouterModule,
    IconsModule,
    NavbarComponent,
    FooterComponent,
    SpinnerComponent,
    YesNoDialogComponent,
    OkDialogComponent,
    PlacesAutocompleteComponent,
    BrowserAnimationsModule,
    BsDropdownModule,
    VisitSlotDatePipe,
    UiSwitchModule,
    SalonFormattedAddressPipe,
    MonthAbbrevTranslationKeyFromDate,
    MonthNameTranslationKeyFromDate,
    WeekDayTranslationKeyFromDate,
    RatingStarsComponent,
    RatingBarComponent,
    ValidateOnBlurDirective,
    BadgeGiftsComponent,
    TruncatePipe,
    ReviewItemComponent,
    UnsupportedBrowserNotificationComponent,
    BadgeGiftsDescriptionDumbComponent
  ],
  providers: [
    CookieService
  ]
})
export class SharedModule { }
